import styled, { keyframes } from "styled-components";
import { Theme } from "../Page";

export const Divider: React.FC = () => {
  return <div className="mx-2.5 my-12 mt-20 h-[1px] bg-gray-400 shadow-lg" />;
};

export const FullPageBanner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > * {
    margin: 10px;
  }
`;

export const InventoryGrid = styled.div<{
  theme: Theme;
  itemWidth?: string;
  itemHeight?: string;
}>`
  /* padding: 5px; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  & > * {
    margin: 10px;
  }

  & > div,
  & a[data-add] {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color),
      0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    border-radius: 0.5rem /* 8px */;
  }
  & > div:hover,
  & a[data-add]:hover {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1),
      0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color),
      0 4px 6px -4px var(--tw-shadow-color);
  }

  /* Inventory Item */
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative; // for spinner in corner

    padding: 10px;
    width: ${(props) => props.itemWidth || "300px"};
    max-width: 100%;
    min-height: ${(props) => props.itemHeight || "90px"};

    /* box-shadow: rgba(0, 0, 0, 0.14) 0 2px 2px 0; */
    /* border: 1px solid rgb(225, 225, 225); */
    /* background-color: #f6f6f6; */
    /* transition: all 0.1s ease; */

    /* This is the "title" bar */
    & > div {
      margin: 10px 5px;
    }

    & > div:first-child,
    & > div.title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    button:not(.visible) {
      opacity: 0;
    }

    button:not(.self-transition) {
      transition: all 0.3s ease;
    }

    &:hover button:not(.free) {
      opacity: 1;
    }

    /* &:target {
      background-color: #e5ffee;
    } */

    /* li {
      & > * {
        margin: 5px;
      }
    }

    li:hover button {
      opacity: 1;
    } */
  }

  /* & > a[data-summary="true"] > div {
    background-color: #81c770;
  } */

  /* & > a > div:hover {
    transform: scale(1.05);
  } */

  /* small {
    padding: 2px 5px;
    margin: 5px;
    background-color: #747474;
    color: white;
    box-shadow: ${(props) => props.theme.bs};
    border-radius: 5px;
  } */

  /* & > a > div > div {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  } */

  & a[data-add] {
    width: 250px;
    height: ${(props) => props.itemHeight || "90px"};
    display: flex;
    justify-content: center;
    align-items: center;
    /* box-shadow: 0px 0px 5px 0px grey; */
    transition: all 0.1s ease;
  }

  & a[data-add]:hover {
    /* cursor: pointer; */
    /* box-shadow: 0px 0px 10px 0px grey; */
  }

  & svg {
    transition: all 0.1s ease;
  }

  & a[data-add]:hover svg {
    transform: scale(1.4);
  }
`;

export const Notice = styled.small<{ theme: Theme; appearance?: string }>`
  padding: 2px 5px;
  margin: 5px;
  background-color: #e7e7e7;
  background-color: ${(props) =>
    props.appearance ? props.theme[props.appearance] : "#e7e7e7"};
  color: ${(props) =>
    props.appearance ? props.theme[`${props.appearance}Color`] : "initial"};
  /* color: white; */
  box-shadow: ${(props) => props.theme.bs};
  border-radius: 5px;
  border: ${(props) => (props.appearance ? "none" : "1px solid #dedede")};
  max-width: 400px;
  display: inline-block;
`;

export const Zone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  border: 1px solid #bcbcbc;
  border-radius: 5px;
  padding-bottom: 20px;

  & > h4:first-child {
    background-color: #bcbcbc;
    color: white;
    width: 100%;
    margin: 0 !important;
    margin-bottom: 10px !important;
    padding: 5px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  & > *:not(:first-child) {
    margin-top: 10px;
  }
`;

export const DangerZone = styled(Zone)`
  border: 1px solid #ffaa0e;

  & > h4:first-child {
    background-color: #ffaa0e;
  }
`;

export const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 10px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

export const fadeDown = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, -10px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

export const ToolTip = styled.div<{
  theme: Theme;
  position: string;
  tooltipWidth: string;
  left: string;
}>`
  display: inline-block;
  position: relative;

  &:hover {
    cursor: help;
  }

  & > span {
    display: none;
    position: absolute;
    ${(props) => (props.position === "bottom" ? "top: 25px" : "bottom: 25px")}
    /* bottom: 25px; */
    left: calc(
      -${(props) =>
      props.left || `${props.tooltipWidth || "300px"} / 2` || "300px"}
    );
    z-index: 5;
    animation: ${(props) => (props.position === "bottom" ? fadeDown : fadeUp)}
      0.3s ease-in-out;

    background-color: white;
    color: black;

    /* width: 300px; */
    width: ${(props) => props.tooltipWidth || "300px"};
    border: 1px solid #ececec;
    border-radius: 5px;
    box-shadow: ${(props) => props.theme.bs};
    padding: 10px;
  }

  &:hover > span {
    display: block;
  }
`;

export const Header = styled.h2`
  display: flex;
  align-items: center;

  & > * {
    margin: 5px;
  }
`;

export const Block = styled.div`
  display: flex;
  /* justify-content: center; */
  align-items: center;

  margin: 5px;

  & > * {
    margin: 5px;
  }

  button:not(.visible) {
    opacity: 0;
    transition: all 0.3s ease;
  }

  &:hover button {
    opacity: 1;
  }
`;

export const Table = styled.table<{ theme: Theme }>`
  border-spacing: 0;
  width: 100%;
  border: 1px solid ${(props) => props.theme.offWhite};
  thead {
    /* font-size: 10px; */
  }
  td {
    /* to accomodate the "save" button */
    height: 50px;
  }
  td,
  th {
    border-bottom: 1px solid ${(props) => props.theme.offWhite};
    border-right: 1px solid ${(props) => props.theme.offWhite};
    padding: 5px;
    position: relative;
    &:last-child {
      border-right: none;
      width: 150px;
      button {
        /* width: 100%; */
      }
    }
    label {
      padding: 10px 5px;
      display: block;
    }
  }
  tr {
    &:hover {
      background: ${(props) => props.theme.offWhite};
    }
  }
`;

export const TitleBar = styled.div<{ sticky?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @media screen {
    ${(props) =>
      props.sticky
        ? `
    position: sticky;
    top: 0px;
  `
        : null}
  }
  z-index: 2;
  min-height: 50px;

  label {
    margin: 15px;
  }

  input[type="text"] {
    padding: 2px 8px;
    min-height: 38px;
    width: 150px;
    border: 1px solid hsl(0, 0%, 80%);
    border-radius: 4px;
    outline: none;
  }

  input:focus[type="text"],
  input:focus-within[type="text"] {
    border-color: #2684ff;
    box-shadow: 0 0 0 1px #2684ff;
  }
`;

export const Input = styled.input`
  margin: 5px;
  min-height: 38px;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid hsl(0, 0%, 80%);

  &:hover {
    border: 1px solid hsl(0, 0%, 70%);
  }
`;
